import { ThemeType } from "project-config/client-theme/client-theme";
import styled from "styled-components";

import PaymentBg from "../../images/payment-bg.png";
import PaymentDarkBg from "../../images/payment-dark-bg.png";

export const PaymentWayWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${(p) =>
    p.theme["name"] === ThemeType.Light
      ? `url(${PaymentBg})`
      : `url(${PaymentDarkBg})`};
  background-size: 100% 100%;
  padding: 0 19px 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0 6px 6px 0;
`;
export const PaymentContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0%;
  margin-top: 42px;
`;

export const QRCodeContainer = styled.div`
  width: 146px;
  height: 146px;
  border: 1px solid ${(p) => p.theme["color-line-2"]};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 0 6px 0;
`;

export const QRCodeLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.theme["gradient-fill-3"]};
  opacity: 0.6;
  border-radius: 6px;
`;

export const HiddenTopLeft = styled.div`
  position: absolute;
  top: 7px;
  left: 7px;
  width: 20px;
  height: 20px;
  background: #fff;
`;

export const QRCodeDisabledProtocol = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.theme["gradient-fill-3"]};
  border-radius: 6px;
  font-size: 12px;
  color: ${(p) => p.theme["color-text-1"]};
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;
`;
export const RefreshButton = styled.div`
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: ${(p) => p.theme["gradient-fill-3"]};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    stroke: ${(p) => p.theme["color-text-1"]};
  }
  span {
    color: ${(p) => p.theme["color-text-1"]};
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Price = styled.div`
  display: flex;
  color: ${(p) => p.theme["color-text-1"]};
  align-items: baseline;
  height: 42px;
  line-height: 42px;
  span:nth-child(3) {
    font-size: 32px;
    color: ${(p) => p.theme["color-text-5"]};
    font-weight: 700;
    margin: 0 2px;
  }
  .unit {
    color: ${(p) => p.theme["color-text-5"]};
    font-size: 16px;
    font-weight: 600;
    margin-left: 6px;
  }
`;
export const RechargeArrivalContent = styled.div`
  display: flex;
  flex-direction: column;
  .arrival-bg {
    width: 120px;
    margin: 0 auto 4px;
  }
`;

export const Gift = styled.div`
  background: ${(p) => p.theme["color-fill-6"]};
  min-width: 146px;
  border: 1px solid ${(p) => p.theme["color-line-2"]};
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 14px;
  font-weight: 400;
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  svg {
    width: 16px;
    margin-right: 4px;
  }

  &.vip-gift {
    font-weight: 600;
    height: 36px;
    margin-top: 6px;
    .member {
      color: #3e88f8;
    }
    .month {
      background: linear-gradient(99.76deg, #ff4895 -3.67%, #9948ff 108.07%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-left: 6px;
    }
  }
`;

export const PayType = styled.div`
  .pay-item {
    display: flex;
    font-size: 14px;
    color: ${(p) => p.theme["color-text-3"]};
    line-height: 22px;
    margin-bottom: 6px;
    .ant-checkbox-checked .ant-checkbox-inner {
      background: #3c7bea !important;
      border-color: #3c7bea !important;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner {
      border-color: #3c7bea !important;
    }
    .ant-checkbox-inner {
      background: ${(p) => p.theme["theme-1"]} !important;
      border-color: ${(p) => p.theme["color-line-1"]};
    }
    label,
    svg {
      flex: none;
      width: 16px;
      height: 16px;
      margin-right: 6px;
      margin-top: 4px;
    }
    button,
    a {
      all: unset;
      color: ${(p) => p.theme["color-text-4"]};
      cursor: pointer;
      &.disabled {
        cursor: not-allowed;
      }
      &:active {
        opacity: 0.9;
      }
    }
    .right-icon {
      width: 12px;
      height: 12px;
      margin-right: 0;
    }
  }
`;
